module.exports = __webpack_public_path__ + "static/media/fourInnerImg1.26927d9d.png";